import { AgentStatusCard, type SpecialistStatus } from "./AgentStatusCard";
import type { AgentInfo, ToolHistoryEntry } from "../../api/types";

interface AgentGridProps {
  agents: AgentInfo[];
  specialistStatuses?: Map<string, SpecialistStatus>;
  toolHistory?: Map<string, ToolHistoryEntry[]>;
}

export function AgentGrid({
  agents,
  specialistStatuses,
  toolHistory,
}: AgentGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 stagger-children">
      {agents.map((agent) => (
        <AgentStatusCard
          key={agent.id}
          agentId={agent.id}
          name={agent.name}
          status={specialistStatuses?.get(agent.id) ?? "idle"}
          toolHistory={toolHistory?.get(agent.id)}
        />
      ))}
    </div>
  );
}
